import * as Yup from 'yup';

const ConfirmIdentitySchema = Yup.object().shape({
    nric: Yup.string().trim()
        // .matches(/^[STFGstfg]\d{7}[A-z]$/, 'Nric format is invalid.')
        .required('Nric is required'),
    name: Yup.string().trim().required(),
    contactNoCountryCode: Yup.string().required(),
    contactNo: Yup.string().trim()
        .min(8)
        .matches(/^[0-9]*$/, 'Mobile No format is invalid.')
        .required()
});

export default ConfirmIdentitySchema;